import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import './EidMubarak.css';
import AdBlockHorizontal from '../Component/Ads/AdBlockHorizontal';
import AdBlockVertical from '../Component/Ads/AdBlockVertical';

const EidMubarak = () => {
  const [fromName, setFromName] = useState('');
  const [showGreeting, setShowGreeting] = useState(false);
  const [generatedUrl, setGeneratedUrl] = useState('');
  const [copySuccess, setCopySuccess] = useState('');
  const [giftOpened, setGiftOpened] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const from = params.get('from');
    if (from) {
      setFromName(from);
      setShowGreeting(true);
    }
  }, []);

  const handleGenerateLink = () => {
    if (fromName.trim()) {
      const url = `${window.location.origin}${window.location.pathname}?from=${encodeURIComponent(fromName)}`;
      setGeneratedUrl(url);
      navigator.clipboard.writeText(url).then(() => {
        setCopySuccess('✅ Link copied to clipboard!');
        setTimeout(() => setCopySuccess(''), 3000);
      });
    }
  };

  const handleInputKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleGenerateLink();
    }
  };

  const handleLinkClick = () => {
    if (generatedUrl) {
      navigator.clipboard.writeText(generatedUrl).then(() => {
        setCopySuccess('✅ Link copied to clipboard!');
        setTimeout(() => setCopySuccess(''), 3000);
      });
    }
  };

  const handleOpenGift = () => {
    setGiftOpened(true);
    setShowConfetti(true);
    setTimeout(() => {
      setShowConfetti(false);
    }, 1800); // matches CSS animation duration
    setTimeout(() => {
      const box = document.querySelector('.gift-box-3d');
      if (box) box.classList.add('opened');
    }, 80);
  };

  // Resets all to allow friend to create own link
  const handleCreateOwnGreeting = () => {
    setFromName('');
    setShowGreeting(false);
    setGeneratedUrl('');
    setCopySuccess('');
    setGiftOpened(false);
    setShowConfetti(false);
    // Optionally remove ?from from URL
    window.history.replaceState({}, document.title, window.location.pathname);
  };

  return (
    <>
      <Helmet>
        <title>Eid ul Adha Mubarak - Funfillia</title>
        <meta name="title" content="Eid ul Adha Mubarak - Funfillia" />
        <meta name="description" content="Send beautiful, interactive Eid ul Adha greetings to your friends with a personalized link. Celebrate with joy, blessings, and fun at Funfillia!" />
        <meta name="keywords" content="Eid, Eid ul Adha, Mubarak, greeting, Islamic, fun, blessings, qurbani, celebration, card, message, Funfillia, share, joy" />
        <meta name="robots" content="index, follow" />
        <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
        <meta name="language" content="English" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#ffe082" />
        <link rel="canonical" href={window.location.href} />
 
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:title" content="Eid ul Adha Mubarak - Funfillia" />
        <meta property="og:description" content="Send beautiful, interactive Eid ul Adha greetings to your friends with a personalized link. Celebrate with joy, blessings, and fun at Funfillia!" />
        <meta property="og:image" content="https://www.funfillia.com/eid-card.png" />
        <meta property="og:site_name" content="Funfillia" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content={window.location.href} />
        <meta name="twitter:title" content="Eid ul Adha Mubarak - Funfillia" />
        <meta name="twitter:description" content="Send beautiful, interactive Eid ul Adha greetings to your friends with a personalized link. Celebrate with joy, blessings, and fun at Funfillia!" />
        <meta name="twitter:image" content="https://www.funfillia.com/eid-card.png" />
        </Helmet>

      <div className="eid-container">
        <div className="stars"></div>

        {!showGreeting ? (
          <div className="input-box fade-in">
            <div className="moon">🌙</div>
            <h1 className="glow-text slide-down">Eid ul Adha Mubarak!</h1>
            {!generatedUrl ? (
              <>
                <p className="typewriter">Enter your name to generate your greeting link</p>
                <input
                  type="text"
                  placeholder="Your Name"
                  value={fromName}
                  onChange={(e) => setFromName(e.target.value)}
                  onKeyDown={handleInputKeyDown}
                />
                <button className="pulse" onClick={handleGenerateLink}>
                  Generate & Copy Link 🔗
                </button>
              </>
            ) : (
              <div className="generated-link fade-in">
                <p>Click below to copy & share your greeting link:</p>
                <input
                  readOnly
                  value={generatedUrl}
                  onClick={handleLinkClick}
                />
                {copySuccess && <div className="copy-success fade-in-up">{copySuccess}</div>}
              </div>
            )}
          </div>
        ) : !giftOpened ? (
          <div className="gift-box-container fade-in">
            <div className="gift-box-3d" onClick={handleOpenGift}>
              <div className="box-base"></div>
              <div className="box-lid"></div>
              <div className="box-ribbon"></div>
              <span className="tap-text">Click to open your Eid surprise!</span>
            </div>
          </div>
        ) : (
          <>
            {showConfetti && <div className="confetti"></div>}
            <div className="eid-box slide-in">
              <div className="moon big">🌙</div>
              <h1 className="glow-text scale-in">Eid Mubarak from {fromName}!</h1>
              <p className="eid-greeting fade-in-up">
                May your Eid be filled with blessings, joy, and beautiful moments.
              </p>
              <div className="bismillah fade-in-delay">بِسْمِ ٱللَّٰهِ ٱلرَّحْمَٰنِ ٱلرَّحِيمِ</div>
              <p>
                On this sacred day of sacrifice, may Allah accept your offerings and fill your heart with peace.
              </p>
              <blockquote>
                "Their meat will not reach Allah, nor will their blood, but what reaches Him is piety from you..." <br />
                <cite>— Quran 22:37</cite>
              </blockquote>
              <p className="closing-dua">
                🤲 With heartfelt wishes, <br />
                <strong>{fromName}</strong> via <strong>Funfillia</strong>
              </p>
              <div className="drum-bounce">🥁🥁🥁</div>
              <button className="pulse" style={{ marginTop: 32 }} onClick={handleCreateOwnGreeting}>
                Create Your Own Eid Greeting 🌙
              </button>
            </div>
          </>
        )}
      </div>

      <div className="ads-horizontal"><AdBlockHorizontal /></div>
    </>
  );
};

export default EidMubarak;
